// import "./App.css";

// import ReactDOM from "react-dom";

// import "./index.css";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import App from "./App";
// import * as serviceWorker from "./serviceWorker";

// ReactDOM.render(
//   <Router>
//     <Routes>
//       <Route path="/*" element={<App />} />
//     </Routes>
//   </Router>,
//   document.getElementById("root")
// );

// // If you want your app to work offline and load faster, you can change
// // unregister() to register() below. Note this comes with some pitfalls.
// // Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

import "./App.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <div>
    <Router>
      <Routes>
        <Route path="*" element={<App />} />
      </Routes>
    </Router>
    ,
  </div>
);

reportWebVitals();
